import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Text } from '../../../shared/uiComponents';

interface User {
	fullName: string;

	id: string;
}

interface UsersListCardProps {
	users: User[];
}

const UsersListCard: FC<UsersListCardProps> = ({ users }) => (
	<div className="insuranceDetailCard">
		<Text title={`Users (${users.length})`} type="h6" fontWeight="semiBold" />
		<div className="listContainer">
			{users.length > 0 ? (
				users.map((user) => (
					<div key={user.id} className="listItem">
						<Link to={`/user/${user.id}`} className="listLink">
							{user.fullName}
						</Link>
					</div>
				))
			) : (
				<Text title="No users" type="psm" color="#999" />
			)}
		</div>
	</div>
);

export default UsersListCard;
